/**
 * Shared number formatting for the Maintenance tabs.
 *
 * Both tabs report the same two quantities about the same tables — how big and
 * roughly how many rows — and they have to agree, or the same table reads as
 * two different sizes depending on which tab you opened.
 */

const BYTE_UNITS = ['B', 'KB', 'MB', 'GB', 'TB'] as const;

/** 15_032_385_536 → "14.0 GB". Binary units, one decimal above bytes. */
export function formatBytes(bytes: number | null): string | null {
  if (bytes === null || !Number.isFinite(bytes) || bytes < 0) return null;
  let value = bytes;
  let unit = 0;
  while (value >= 1024 && unit < BYTE_UNITS.length - 1) {
    value /= 1024;
    unit += 1;
  }
  return unit === 0
    ? `${value} ${BYTE_UNITS[unit]}`
    : `${value.toFixed(1)} ${BYTE_UNITS[unit]}`;
}

const COMPACT_NUMBER = new Intl.NumberFormat(undefined, {
  notation: 'compact',
  maximumFractionDigits: 1,
});

/** 31_750_000 → "31.8M". For the planner's row estimate, which is approximate anyway. */
export function formatRowEstimate(rows: number | null): string | null {
  return rows === null ? null : COMPACT_NUMBER.format(rows);
}
